import React from "react";
import { Skeleton } from "antd";

import { AVATAR_SIZE, StaffMemberContainer } from "./BusinessStaffMember.styles";

const BusinessStaffMemberSkeleton: React.FC = () => {
  return (
    <StaffMemberContainer vertical>
      <Skeleton.Avatar active size={AVATAR_SIZE} />
      <Skeleton active paragraph={false} />
    </StaffMemberContainer>
  );
};

export default BusinessStaffMemberSkeleton;
